// Reads values from the Delphi-era user settings, stored as INI text (e.g. "[SYSTEM]\r\nShowTakeOwnership=1").
// Section and key names are matched case-insensitively, as Delphi's TIniFile does.

// Without a section, returns the first matching key in any section; with one, only looks in that section.
export function getLegacySetting(settings: string | undefined | null, name: string, section?: string): string | undefined {
    if (!settings) return undefined;

    const wantedName = name.trim().toLowerCase();
    const wantedSection = section?.trim().toLowerCase();
    let currentSection = "";

    for (const line of settings.split(/\r?\n|\r/)) {
        const trimmed = line.trim();

        const header = /^\[(.+)\]$/.exec(trimmed);
        if (header) {
            currentSection = header[1].trim().toLowerCase();
            continue;
        }

        if (wantedSection !== undefined && currentSection !== wantedSection) continue;

        const equals = trimmed.indexOf("=");
        if (equals > 0 && trimmed.slice(0, equals).trim().toLowerCase() === wantedName) {
            return trimmed.slice(equals + 1).trim();
        }
    }

    return undefined;
}

// True when the setting is "1"; returns fallback when the setting isn't present.
export function isLegacySettingOn(
    settings: string | undefined | null,
    name: string,
    section?: string,
    fallback = false,
): boolean {
    const value = getLegacySetting(settings, name, section);
    return value === undefined ? fallback : value === "1";
}
